<template>
  <button
    :class="[$style.button,
             small && $style.small,
             windowsWidth <=700 && $style.mobileButton]"
  >
    <slot />
  </button>
</template>

<style lang="scss" module>
.button {
  font-size: 1.2rem;
  font-weight: bold;
  min-height: 48px;
  padding: 9px 20px;
  cursor: pointer;
  letter-spacing: 1.1px;
  border: solid 1px #fff8fb;
  margin: 10px;
  border-radius: 100px;
  outline: none;
  background-color: #fff;
  color: #e64a83;
  transition: background-color 0.2s;

  &.small {
    min-height: 30px;
    padding: 12px 25px;
    font-size: 14px;
  }

  &.mobileButton {
    padding: 12px 20px;
    font-size: 1.4rem;
  }

  &:active:enabled {
    background-color: #e73273;
  }
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      windowsWidth: state => state.ui.windowsWidth,
    }),
  },
};
</script>
